import { render } from "./FamiliaLanding.vue?vue&type=template&id=c71cf1c0&scoped=true"
import script from "./FamiliaLanding.vue?vue&type=script&lang=js"
export * from "./FamiliaLanding.vue?vue&type=script&lang=js"

import "./FamiliaLanding.vue?vue&type=style&index=0&id=c71cf1c0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71cf1c0"]])

export default __exports__